"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSubscriptionsAction = exports.getSubscriptionsAction = void 0;
const store_1 = require("../../../../exports/store");
const datasheet_api_1 = require("../../api/datasheet_api");
/**
 * get current datasheet/mirrors' subscribed(followed) record ids
 * @param datasheetId
 * @param mirrorId
 * @returns
 */
const getSubscriptionsAction = (datasheetId, mirrorId) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield (0, datasheet_api_1.getSubscriptions)(datasheetId, mirrorId);
    if (data === null || data === void 0 ? void 0 : data.success) {
        dispatch((0, exports.setSubscriptionsAction)(data.data || []));
    }
});
exports.getSubscriptionsAction = getSubscriptionsAction;
/**
 * update current subscribed(followed) records ids
 * @param recordIds
 * @returns
 */
const setSubscriptionsAction = (recordIds) => ({
    type: store_1.ActionConstants.SET_SUBSCRIPTIONS,
    payload: recordIds,
});
exports.setSubscriptionsAction = setSubscriptionsAction;
//# sourceMappingURL=subscriptions.js.map